import React, { useEffect, useRef, useState } from 'react'
import SectionWithTag, { Side } from '../../components/SectionWithTag'
import TestimonialPicture from './components/TestimonialPicture'
import TestimonialText from './components/TestimonialText'
import HorizontalScroll from '../../components/HorizontalScroll'
import TestimonialNavigation from './components/TestimonialNavigation'
import { twMerge } from 'tailwind-merge'
import { SetPaddingProps } from '../../utils/PaddingContext'
import { slug } from '../../utils/helpers'

interface TestimonialsMobileProps extends SetPaddingProps {
  data: any[]
}

const TestimonialsMobile = ({ data, setPadding }: TestimonialsMobileProps) => {
    const [currentTestimonial, setCurrentTestimonial] = useState(0)
    const scrollRef = useRef<HTMLDivElement>(null)

    useEffect(() => {
        const calculatePadding = () => {
            requestAnimationFrame(() => {
                setPadding()
            })
        }
        calculatePadding()
        window.addEventListener('resize', calculatePadding)
        return () => {
            window.removeEventListener('resize', calculatePadding)
        }
    }, [setPadding])

    useEffect(() => {
        const roundByEqualValue = (value: number) => {
            const part = data.length - 1
            return Math.round(value * part) / part
        }

        const scrollHandler = () => {
            // @ts-ignore
            const { scrollLeft: scrl, scrollWidth, clientWidth } = scrollRef.current
            const percentage = roundByEqualValue(scrl / (scrollWidth - clientWidth))
            setCurrentTestimonial((data.length - 1) * percentage)
        }
        if (scrollRef.current) {
            scrollRef.current.addEventListener('scroll', scrollHandler)
        }
    }, [scrollRef, data.length])

    const setTestimonial = (value: number) => {
        const leftScroll =
      document.querySelectorAll('.testimonial-item')?.[value]?.getBoundingClientRect().left ?? 0
    scrollRef.current?.scrollBy(leftScroll, 0)
    }
    return (
        <div className='border-t border-black/10 bg-white py-12'>
            <SectionWithTag
                tag={{ id: 'page.partnerships.testimonials' }}
                className='content-grid--tag-small content-grid--testimonial'
                contentClasses='px-0'
                side={Side.LEFT}
            >
                <HorizontalScroll ref={scrollRef} wrapperClasses='scroll-px-6 px-6 gap-x-6'>
                    {data.map((item) => (
                        <TestimonialMobileItem item={item} key={slug(item.company)} />
                    ))}
                </HorizontalScroll>
                <div className='flex justify-center'>
                    <TestimonialNavigation
                        count={data.length}
                        currentTestimonial={currentTestimonial}
                        setCurrentTestimonial={setTestimonial}
                    />
                </div>
            </SectionWithTag>
        </div>
    )
}

const TestimonialMobileItem = ({ item }: any) => {
    return (
        <div
            className='flex-none snap-start flex flex-col gap-y-5 testimonial-item'
            style={{ width: 'calc(100vw - 3rem)' }}
        >
            <TestimonialPicture
                slug={item.picture}
                className={twMerge(item.pictureClasses, 'aspect-square object-contain')}
            />
            <TestimonialText {...item} />
        </div>
    )
}

export default TestimonialsMobile
